import React from 'react';
import { Facebook, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  const quickLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'In-Store Selection',
    href: '/store-tour'
  }, {
    name: 'Services & Classes',
    href: '/services'
  }, {
    name: 'Store Tour',
    href: '/store-tour'
  }, {
    name: 'Events',
    href: '/events'
  }, {
    name: 'FAQ',
    href: '/faq'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const selectionLinks = [{
    name: 'Firearms',
    href: '/firearms'
  }, {
    name: 'Ammunition',
    href: '/ammunition'
  }, {
    name: 'Optics',
    href: '/optics'
  }, {
    name: 'Reloading Supplies',
    href: '/reloading-supplies'
  }, {
    name: 'Safes & Accessories',
    href: '/safes-accessories'
  }, {
    name: 'Hunting Gear & Blinds',
    href: '/hunting-gear-blinds'
  }];
  const serviceLinks = [{
    name: 'Gunsmithing & In-Store Support',
    href: '/services'
  }, {
    name: 'Minnesota Permit to Carry Classes',
    href: '/mn-permit-to-carry-classes'
  }, {
    name: 'NFA / Form 4 In-Store Support',
    href: '/services'
  }, {
    name: 'Questions & Transfers',
    href: '/services'
  }];
  return <footer className="bg-brand-charcoal text-brand-cream pt-16 pb-24 lg:pb-8" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-33">
          {/* Column 1: Brand & Contact */}
          <div data-id="element-34">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.ksportsllc.com/uploaded/images/Updated-logo.png?opt=w3" alt="Kjergaard Sports logo" className="h-16 w-auto mb-6 brightness-0 invert opacity-90" data-id="element-35" />
            <p className="font-serif italic text-brand-leather mb-6 text-lg" data-id="element-36">
              Where the service and price are worth the trip.
            </p>
            <div className="space-y-3 text-brand-bone/80" data-id="element-37">
              <p className="flex items-start" data-id="element-38">
                <MapPin className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" data-id="element-39" />
                <span data-id="element-40">
                  1951 200th Avenue
                  <br data-id="element-41" />
                  Lake Benton, Minnesota 56149
                </span>
              </p>
              <p className="flex items-center" data-id="element-42">
                <Phone className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-43" />
                <a href="tel:507-368-4696" className="hover:text-brand-leather transition-colors" data-id="element-44">
                  507-368-4696
                </a>
              </p>
              <p className="flex items-center pt-2" data-id="element-45">
                <a href="https://www.facebook.com/profile.php?id=100057537217940" target="_blank" rel="noopener noreferrer" className="text-brand-bone hover:text-[#1877F2] transition-colors flex items-center" data-id="element-46">
                  <Facebook className="w-5 h-5 mr-3" data-id="element-47" />
                  Follow on Facebook
                </a>
              </p>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-48">
            <h3 className="text-lg font-serif text-brand-offwhite mb-6" data-id="element-49">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-50">
              {quickLinks.map(link => <li key={link.name} data-id="element-51">
                  <Link to={link.href} className="text-brand-bone/80 hover:text-brand-leather transition-colors" data-id="element-52">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Selection */}
          <div data-id="element-53">
            <h3 className="text-lg font-serif text-brand-offwhite mb-6" data-id="element-54">
              In-Store Selection
            </h3>
            <ul className="space-y-3" data-id="element-55">
              {selectionLinks.map(link => <li key={link.name} data-id="element-56">
                  <Link to={link.href} className="text-brand-bone/80 hover:text-brand-leather transition-colors" data-id="element-57">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Column 4: Services */}
          <div data-id="element-58">
            <h3 className="text-lg font-serif text-brand-offwhite mb-6" data-id="element-59">
              Services &amp; Classes
            </h3>
            <ul className="space-y-3" data-id="element-60">
              {serviceLinks.map(link => <li key={link.name} data-id="element-61">
                  <Link to={link.href} className="text-brand-bone/80 hover:text-brand-leather transition-colors" data-id="element-62">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-brand-bone/20" data-id="element-63">
          <p className="text-brand-bone/60 text-sm mb-4" data-id="element-64">
            This website is for business information only. Kjergaard Sports does
            not conduct sales directly through this website. All firearm-related
            sales, transfers, and regulated services are handled in-store and in
            accordance with applicable laws.
          </p>
          <p className="text-brand-bone/40 text-sm" data-id="element-65">
            &copy; {new Date().getFullYear()} Kjergaard Sports. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}